import { Component } from '@angular/core';

@Component({
  selector: 'app-main-layout',
  templateUrl: './content-layout.component.html',
})
export class ContentLayoutComponent {}
